class V2GridBlock {
  constructor(container) {
    this.container = container;
    this.swiper = null;
    this.init();
  }

  init() {
    this.initSwiper();
    this.bindEvents();
  }

  initSwiper() {
    if (window.innerWidth <= 990 && typeof Swiper !== 'undefined') {
      const swiperEl = this.container.querySelector('.v2-grid-block__swiper');
      const paginationEl = this.container.querySelector('.swiper-pagination');

      if (swiperEl && !this.swiper) {
        this.swiper = new Swiper(swiperEl, {
          slidesPerView: 'auto',
          spaceBetween: 8,
          pagination: {
            el: paginationEl,
            clickable: true
          }
        });

        this.bindNavigation();
      }
    }
  }

  bindNavigation() {
    const prevBtn = this.container.querySelector('.v2-grid-block__nav-btn--prev');
    const nextBtn = this.container.querySelector('.v2-grid-block__nav-btn--next');

    if (prevBtn && this.swiper) {
      prevBtn.addEventListener('click', () => this.swiper.slidePrev());
    }

    if (nextBtn && this.swiper) {
      nextBtn.addEventListener('click', () => this.swiper.slideNext());
    }
  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  bindEvents() {
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  handleResize() {
    if (window.innerWidth <= 990) {
      this.initSwiper();
    } else {
      this.destroySwiper();
    }
  }

  destroy() {
    this.destroySwiper();
    window.removeEventListener('resize', this.handleResize.bind(this));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.v2-grid-block').forEach((section) => {
    new V2GridBlock(section);
  });
});

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector('.v2-grid-block');
  if (section) {
    new V2GridBlock(section);
  }
});
